	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Geometry.Geometry;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Geometry/Geometry.js
// module id = 19
// module chunks = 0